import CustomDialog from "app/components/CustomDialog";
import { Box, Button, Typography } from "@mui/material";
import useAuth from "app/hooks/useAuth";

const UpdateJobStatusDialog = ({ open, onClose, onConfirm, selectedJob }) => {
  const { user } = useAuth();
  const isJobEnabled = selectedJob?.jp_is_enabled;
  const jobId = selectedJob?.jp_id;
  const status = isJobEnabled ? "disable" : "enable";
  const updatedBy = user?.id || "Admin"; // This should ideally come from logged in user info
  return (
    <CustomDialog
      dialogTitle={`Open/Close Job Posting`}
      fullWidth
      maxWidth={"xs"}
      onClose={onClose}
      open={open}
    >
      {/* Dialog Content */}
      <Box display={"flex"} width={"100%"} flexDirection={"column"} gap={2} p={2}>
        {isJobEnabled ? (
          <Box>
            <Typography>
              Are you sure you want to <strong>CLOSE</strong> the job posting for "
              <strong>{selectedJob?.jp_title}</strong>"?
            </Typography>
            <Typography>
              This will make the job posting invisible to candidates, and you will no longer receive
              new applications for this job.
            </Typography>
          </Box>
        ) : (
          <Box>
            <Typography>
              Are you sure you want to <strong>OPEN</strong> the job posting for "
              <strong>{selectedJob?.jp_title}</strong>"?
            </Typography>
            <Typography> This action will make the job visible to candidates.</Typography>
          </Box>
        )}
        <Box display={"flex"} justifyContent={"flex-end"} gap={2} mt={3}>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            onClick={() => onConfirm(jobId, status, updatedBy)}
            variant="contained"
            color="primary"
          >
            {isJobEnabled ? "Disable Job" : "Enable Job"}
          </Button>
        </Box>
      </Box>
    </CustomDialog>
  );
};

export default UpdateJobStatusDialog;
